import React from "react";
import List from "@material-ui/core/List";
import DialogContent from "@material-ui/core/DialogContent";

const SearchPageBody = (props: any) => {
    return (
        <DialogContent
            dividers
        >
            <List >
                { props.children }
            </List>
        </DialogContent>
    );
};

export default SearchPageBody;